import {createContext} from "react";
import useBusinessQueries from "../hooks/queries/useBusinessQueries";
import {useQuery} from "../hooks/hooks";
import {fromBase64} from "js-base64";
import SubscriptionStepper from "../components/SubscriptionStepper";
import DinoDialog from "../components/Dialog";

const SubscriptionContext = createContext();

export default SubscriptionContext;

export const SubscriptionProvider = ({ children }) => {
    let query = useQuery()
    const simpleRaw = query?.get('r');
    let simpleResponse = null
    if (simpleRaw) simpleResponse = JSON.parse(fromBase64(simpleRaw))

    const {businessGetBillingServicesQuery, businessGetPlanFeaturesQuery, businessGetSubscriptionInfoQuery} = useBusinessQueries()
    const {data: features, isPending: featuresLoading} = businessGetPlanFeaturesQuery
    const {data: services, isPending: servicesLoading} = businessGetBillingServicesQuery
    const {data: subscriptionInfo, isPending: subscriptionInfoLoading} = businessGetSubscriptionInfoQuery

    const billingAvailable = () => Boolean(services.find(b => b.active))

    const hasPlan = (resource, action) => {
        if (featuresLoading) return false
        if (Object?.entries(features).length === 0) return false
        const feature = features?.find(f => f?.resource === resource)
        if (feature == null) return false;
        const permission = feature?.[action]
        if (permission == null) return false;
        if (typeof permission === "boolean") return permission;
        return false
    }

    const contextData = {
        services,
        billingAvailable,
        hasPlan,
        subscriptionInfo
    }

    if (servicesLoading || subscriptionInfoLoading) return null

    return <SubscriptionContext.Provider value={contextData}>
        {children}
        <DinoDialog open={(!subscriptionInfo?.subscription_active && !simpleResponse)}
                    handleClose={() => console.log('Cant close this!')}
                    title='Előfizetés megújítása!'
                    subtitle='Lejárt a próbaidőszakod és nem adtál meg kártyát, vagy nem tudtuk levonni a pénzt a megadott kártyádról!'
        >
            <SubscriptionStepper />
        </DinoDialog>
    </SubscriptionContext.Provider>
}